import { computed, onMounted, ref } from 'vue'
import { translate } from 'src/layouts/core-layout/_functions/translate'
import {
  MEDCARD_STATUS,
  type MedcardStatus,
} from 'src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/SideMenu.constants'
import type { ContextStore } from 'src/layouts/core-layout/types'
import getApiClient from 'src/utils/getApiClient'
import { useContextStore } from 'src/store'

export default function useSideMenuMedcard() {
  const { context }: ContextStore = useContextStore()
  const medtochkaUrl = context.global.sites.siteNameAppMT || ''
  const isRealPatient = Boolean(context.request.user.patient_profile)
  const medcardStatus = ref<MedcardStatus>(null)

  const medcardStatusText = computed(() => {
    if (medcardStatus.value === MEDCARD_STATUS.EXPIRED) {
      return translate('Заблокирована')
    }

    if (medcardStatus.value === MEDCARD_STATUS.NEED_CONFIRMATION) {
      return translate('Подтвердите доступ')
    }

    return null
  })

  async function setupMedcardStatus() {
    if (typeof window === 'undefined' || !medtochkaUrl) {
      return
    }

    try {
      const axiosClient = getApiClient()
      const response = await axiosClient.get(`${medtochkaUrl}/api/me/`, {
        withCredentials: true,
      })

      medcardStatus.value = (response.data?.medcard_status || null) as MedcardStatus
    } catch {
      // Empty
    }
  }

  onMounted(async () => {
    if (isRealPatient) {
      await setupMedcardStatus()
    }
  })

  return {
    medcardStatusText,
  }
}
